/**
 * Detects if Contentful rich text JSON contains legacy markdown syntax
 * Legacy syntax includes: {hr}, *text*, +[link|url]+, etc.
 *
 * @param {Object} contentfulData - Contentful rich text object with format { json: { content: [...] } }
 * @returns {Boolean} - True if legacy markdown syntax is detected
 */
const isLegacyContentfulMarkdown = contentfulData => {
    if (!contentfulData || !contentfulData.json || !contentfulData.json.content) {
        return false;
    }

    // Legacy markdown patterns to detect
    const legacyPatterns = [
        /\{hr\}/i, // Horizontal rule
        /\+\[.*?\|.*?\]\+/, // Legacy link syntax: +[text|url]+
        /\*[^*]+\*(?!\*)/, // Single asterisk italic (not bold **): *text*
        /\^[^^]+\^/, // Legacy superscript: ^text^
        /~[^~]+~(?!~)/, // Legacy subscript (not strikethrough ~~): ~text~
        /\{color:[^}]+\}/, // Legacy color syntax: {color:red}text{color}
        /\{anchor:/, // Legacy anchor syntax
        /\{code\}/, // Legacy code block
        /\{panel\}/, // Legacy panel
        /\{quote\}/ // Legacy quote
    ];

    /**
     * Recursively check all text nodes for legacy patterns
     */
    const checkNode = node => {
        if (node.nodeType === 'text' && node.value) {
            // Check if text contains any legacy patterns
            return legacyPatterns.some(pattern => pattern.test(node.value));
        }

        if (node.content && Array.isArray(node.content)) {
            // Recursively check child nodes
            return node.content.some(checkNode);
        }

        return false;
    };

    // Check all top-level content nodes
    return contentfulData.json.content.some(checkNode);
};

export default isLegacyContentfulMarkdown;
